import React, { useState } from "react";
import { svg } from "../../../resources/Svg";

const FeedbackAlert = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      {isOpen && (
        <section className="flex justify-center items-center w-screen h-14 bg-blue-400 bg-opacity-20">
          <div className="flex items-center space-x-5">
            <div className="flex items-center text-center space-x-1 py-3 px-1">
              <div className="w-5 h-5 text-blue-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <h1 className="text-blue-600 font-medium text-sm">
                The site is under development so you will probably face some
                bugs and uncompleted features
              </h1>
            </div>

            <svg
              className="h-5 w-5 text-blue-600 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              onClick={() => setIsOpen(false)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
        </section>
      )}
    </>
  );
};

export default FeedbackAlert;
